import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import NavigatePage from '../components/NavigatePage/NavigatePage'
import { useNavigate } from 'react-router-dom';
import TrackingImage from '../assets/TrackingOrder.jpg';
export default function TrackOrder() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState()
      const isValid = formData === '' || formData === undefined

      const handleChange = (event) => {
        setFormData(event.target.value)
      };
      const handleTrackOrderClick = () =>{
navigate(`/product/tracking?trackingId=${formData}`)
      }
  return (
    <div>  
         <NavigatePage />
        <Box>
    <img src={TrackingImage} alt="tracking" style={{width:'300px', height:'250px'}}/>
</Box>
<Typography variant='h4' sx={{color:'rgba(86, 4, 246, 1)', textAlign:'center', fontFamily: theme=> theme.typography.bigText}}>
    Track Your Order
</Typography>
<Typography sx={{fontSize:'.8rem', textAlign:'center', my:2, fontFamily: theme=> theme.typography.smallText,}}>
    Track your order effortlessly! Enter your tracking code sent to your email and whatsapp phone  number below to get real-time updates on your delivery status.
</Typography>
<form>
    <Box sx={{display:'flex', justifyContent:'center'}}>
        <TextField value={formData}
  onChange={handleChange} placeholder='enter tracking number' sx={{my:2}} fullWidth/>
    </Box>
    <Box sx={{display:'flex', justifyContent:'center', marginBottom: 2,}}>
    <Button variant="contained"
        // onClick={()=>setTrackingbarState(isValid?true:false)}
        onClick={handleTrackOrderClick}
        disabled={isValid}
        required
          sx={{width:'80%',display:'flex', alignItems:'center', gap:1, textTransform:'none','&.Mui-disabled': {
    backgroundColor: 'rgba(86, 4, 246, 0.2)', // Background color when button is disabled
    color: 'rgba(255, 255, 255, 1)', // Text color when button is disabled
  }, color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
    backgroundColor:'#4f03e7', fontFamily: theme=> theme.typography.smallText,
   
    fontWeight:600,
    boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
  }}}>Track Order</Button>
  </Box>
</form></div>
  )
}
